export default {
      id: "menu-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#menu-usage",
      toString: function () {
        return this.url;
      }
    }